// extracted by mini-css-extract-plugin
module.exports = {"rowWarning":"WarningLabel_rowWarning__KspZ7"};